export const formatToShort = (date: string, locale: string = 'en_US') =>
  new Intl.DateTimeFormat(locale.replace('_', '-'), {
    month: 'short',
    day: 'numeric',
  }).format(new Date(date));
